import { RadioGroup } from "@/components/ui/radio-group";
import { categorizedDataOnlyPackages } from "@/helpers/categorizedDataOnlyPackages";
import { Package } from "@/types/packages/data-only/DataOnlyCountryPackages";
import CountryPackageCard from "./DataOnlyPackageCard";
import DataVoicePackageCard from "./DataVoicePackageCard";

function PackagesGrid({
  selectedPackageId,
  handleValueChange,
  filteredPackages,
  isDataOnlyPackagesSelected,
  isDataVoicePackagesSelected,
  setSelectedPackageId,
  countryFlag,
  countryName,
}: {
  selectedPackageId: string;
  handleValueChange(packageId: string): void;
  isDataOnlyPackagesSelected: boolean;
  isDataVoicePackagesSelected: boolean;
  filteredPackages: Package[];
  countryFlag: string;
  setSelectedPackageId: (value: string) => void;
  countryName: string;
  haveFilteredPackages: boolean;
}) {
  const {
    limitedPackages,
    unlimitedDataPackages,
    unlimitedPlusPackages,
    unlimitedPremiumPackages,
  } = categorizedDataOnlyPackages(filteredPackages);

  //1. if user select unlimited packages then it will select first item in unlimited packages array
  //2. if user select limited packages then it will select first item in limited packages array
  // useEffect(() => {
  //   if (unlimitedDataPackages.length > 0) {
  //     setSelectedPackageId(unlimitedDataPackages[0].id);
  //   } else if (unlimitedPlusPackages.length > 0) {
  //     setSelectedPackageId(unlimitedPlusPackages[0].id);
  //   } else if (unlimitedPremiumPackages.length > 0) {
  //     setSelectedPackageId(unlimitedPremiumPackages[0].id);
  //   } else if (haveFilteredPackages) {
  //     setSelectedPackageId(filteredPackages[0].id);
  //   } else {
  //     setSelectedPackageId("");
  //   }

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [filteredPackages?.[0]?.id]);

  return (
    <>
      {/* Data Only Packages  */}
      <RadioGroup
        value={selectedPackageId}
        onValueChange={handleValueChange}
        className={`grid grid-cols-2 gap-x-2 gap-y-4 sm:gap-x-4 sm:gap-y-4 md:grid-cols-3 xxl:grid-cols-4 ${!isDataOnlyPackagesSelected && "hidden"} items-stretch`}
      >
        {unlimitedDataPackages.slice(0, 1).map((packageDetail, index) => (
          <div key={index} className="h-full">
            <CountryPackageCard
              key={index}
              packageDetail={packageDetail}
              index={index}
              setSelectedPackageId={setSelectedPackageId}
              selectedPackageId={selectedPackageId}
              countryFlag={countryFlag}
              countryName={countryName}
              packagesToSelect={unlimitedDataPackages}
            />
          </div>
        ))}
        {unlimitedPlusPackages.slice(0, 1).map((packageDetail, index) => (
          <div key={index} className="h-full">
            <CountryPackageCard
              key={index}
              packageDetail={packageDetail}
              index={index}
              setSelectedPackageId={setSelectedPackageId}
              selectedPackageId={selectedPackageId}
              countryFlag={countryFlag}
              countryName={countryName}
              packagesToSelect={unlimitedPlusPackages}
            />
          </div>
        ))}
        {unlimitedPremiumPackages.slice(0, 1).map((packageDetail, index) => (
          <div key={index} className="h-full">
            <CountryPackageCard
              key={index}
              packageDetail={packageDetail}
              index={index}
              setSelectedPackageId={setSelectedPackageId}
              selectedPackageId={selectedPackageId}
              countryFlag={countryFlag}
              countryName={countryName}
              packagesToSelect={unlimitedPremiumPackages}
            />
          </div>
        ))}

        {limitedPackages.map((packageDetail, index) => (
          <div key={index} className="h-full">
            <CountryPackageCard
              key={index}
              packageDetail={packageDetail}
              index={index}
              setSelectedPackageId={setSelectedPackageId}
              selectedPackageId={selectedPackageId}
              countryFlag={countryFlag}
              countryName={countryName}
            />
          </div>
        ))}
      </RadioGroup>

      {/* Data Voice Packages */}
      <RadioGroup
        value={selectedPackageId}
        onValueChange={handleValueChange}
        className={`grid grid-cols-2 gap-x-2 gap-y-4 sm:gap-x-4 sm:gap-y-4 md:grid-cols-3 xl:grid-cols-4 ${!isDataVoicePackagesSelected && "hidden"} items-stretch`}
      >
        {filteredPackages.map((item, index) => (
          <div key={index} className="h-full">
            <DataVoicePackageCard
              selectedPackageId={selectedPackageId}
              setSelectedPackageId={setSelectedPackageId}
              index={index}
              packageDetail={item}
              key={index}
              countryFlag={countryFlag}
              countryName={countryName}
            />
          </div>
        ))}
      </RadioGroup>
    </>
  );
}

export default PackagesGrid;
